import PoweredByLumetier from "@/components/PoweredByLumetier";

/**
 * Editorial sign-off rendered under every gallery. Photographer-authored text
 * in `signature_block` appears first; the Lumetier wordmark sits below it as a
 * quiet powered-by line so the studio brand always leads.
 */
export default function FooterSignature({ gallery, variant = "light" }) {
  const isDark = variant === "dark";
  const tone = isDark ? "text-stone-300" : "text-stone-600";
  return (
    <footer
      className={`px-6 py-20 sm:py-28 text-center ${isDark ? "bg-stone-950 text-stone-300" : "bg-stone-50 text-stone-700"}`}
      data-testid="gallery-footer"
    >
      <div
        className="h-px w-12 mx-auto mb-10"
        style={{ backgroundColor: "var(--gallery-accent)" }}
      />
      {gallery.signature_block ? (
        <div
          className={`max-w-xl mx-auto text-sm sm:text-base leading-relaxed ${tone} whitespace-pre-line`}
          style={{ fontFamily: "var(--gallery-font-serif)" }}
          data-testid="gallery-signature"
        >
          {gallery.signature_block}
        </div>
      ) : (
        <div
          className={`text-xs tracking-[0.32em] uppercase ${tone}`}
          style={{ fontFamily: "var(--gallery-font-sans)" }}
        >
          {gallery.studio_name ? `Photographed by ${gallery.studio_name}` : "Thank you"}
        </div>
      )}
      <div className="mt-10">
        <PoweredByLumetier variant={isDark ? "dark" : "light"} />
      </div>
    </footer>
  );
}
